// extracted by mini-css-extract-plugin
export default {"container":"Sp-z","brandName":"Tp-z","productName":"Up-z","productNamePdpEnhancements":"Vp-z","breakLongProductName":"Wp-z"};